<template>
  <v-card>
    <v-card-text>
      <v-row>
        <v-col cols="12">
          <v-text-field class="mt-5" label="Title" v-model.trim="doc.title" :rules="titleRules" type="text"
            placeholder="Title" id="title" required></v-text-field>

          <v-text-field class="mt-5" label="Code" v-model.trim="doc.code" type="text" placeholder="Code" id="code"
            required></v-text-field>

          <v-textarea label="Description" v-model.trim="doc.description" type="text" placeholder="Description"
            id="description" rows="2"></v-textarea>

          <v-select :items="categories" label="Category" v-model.trim="doc.categories" :rules="categoryRules"
            required></v-select>

          <v-select :items="zones" label="Type" v-model.trim="doc.zones" :rules="categoryRules" required></v-select>

          <unit-sub-items v-model="doc.subitems" name="sub">
            <v-label><span class="black--text">What messages does this sign need to cummunicate</span></v-label>
            <p class="ma-0">Type below and press <strong>Add</strong></p>
          </unit-sub-items>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { UnitSubItems } from "@/components/units";

export default {
  name: "UserMappingForm",
  data() {
    return {
      items: [],
      titleRules: [(v) => !!v || "Title is required"],
      categoryRules: [(v) => !!v || "Category is required"],
      search: null,
    };
  },
  props: {
    doc: {
      type: Object,
      default: () => { },
    },
    categories: {
      type: Array,
      default: () => [],
    },
    zones: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    UnitSubItems,
  },
  methods: {},
};
</script>
